const cards = [
  {
    title: '台北娜娜感情线全梳理：从素人到网红的情感进化史',
    desc: '深度梳理台北娜娜从出道至今的感情历程，每段关系背后不为人知的故事与细节，51吃瓜大赛独家整理。',
    author: '吃瓜编辑组',
    time: '2小时前',
    reads: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20editorial%20photography%20with%20soft%20crimson%20and%20rose%20tones%2C%20elegant%20abstract%20composition%2C%20modern%20Chinese%20entertainment%20media%20aesthetic%2C%20dreamy%20atmosphere%20with%20soft%20lighting%2C%20no%20text%20no%20faces%20no%20people&width=800&height=500&seq=card-01-nana-love&orientation=landscape',
    tag: '台北娜娜',
  },
  {
    title: '莫里秀人设崩塌始末：从万人追捧到千夫所指的180天',
    desc: '完整记录莫里秀如何从顶流网红一步步走向争议中心，51吃瓜大赛带来最详尽的事件全纪录。',
    author: '深度调查组',
    time: '5小时前',
    reads: '9.6万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20editorial%20photography%20with%20deep%20burgundy%20and%20shadow%20tones%2C%20cinematic%20atmosphere%20suggesting%20downfall%2C%20modern%20Chinese%20gossip%20media%20aesthetic%2C%20stark%20contrast%20lighting%2C%20no%20text%20no%20faces%20no%20people&width=800&height=500&seq=card-02-mori-fall&orientation=landscape',
    tag: '莫里秀',
  },
  {
    title: '解构玩偶姐姐：一个匿名网红如何构建千万级商业帝国',
    desc: '51吃瓜大赛独家解密玩偶姐姐的商业版图，从账号矩阵到变现模式，这不仅仅是一个网红故事。',
    author: '商业观察室',
    time: '8小时前',
    reads: '8.3万',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20luxurious%20editorial%20photography%20with%20dark%20crimson%20and%20gold%20tones%2C%20abstract%20business%20empire%20aesthetic%2C%20modern%20Chinese%20media%20style%2C%20rich%20dark%20textures%20with%20warm%20highlights%2C%20no%20text%20no%20faces%20no%20people&width=800&height=500&seq=card-03-doll-business&orientation=landscape',
    tag: '玩偶姐姐',
  },
  {
    title: '娱乐圈税务风暴再升级：哪些明星可能成为下一个目标',
    desc: '随着税务部门加大稽查力度，多位艺人被约谈。51吃瓜大赛盘点最有可能被卷入的明星名单。',
    author: '时事观察组',
    time: '12小时前',
    reads: '7.1万',
    img: 'https://readdy.ai/api/search-image?query=Serious%20dark%20editorial%20photography%20with%20charcoal%20and%20burgundy%20tones%2C%20dramatic%20legal%20investigation%20aesthetic%2C%20modern%20Chinese%20news%20media%20style%2C%20stark%20contrast%20and%20shadow%2C%20no%20text%20no%20faces%20no%20people&width=800&height=500&seq=card-04-tax-storm&orientation=landscape',
    tag: '明星八卦',
  },
  {
    title: '2026网红生存图鉴：流量红利消退后的转型与挣扎',
    desc: '当流量红利逐渐消退，曾经风光无限的网红们正在经历怎样的转型阵痛？51吃瓜大赛深度观察。',
    author: '行业分析组',
    time: '1天前',
    reads: '5.5万',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20photography%20with%20warm%20amber%20and%20crimson%20gradients%2C%20abstract%20composition%20evoking%20transition%20and%20change%2C%20modern%20Chinese%20digital%20media%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20no%20text%20no%20faces%20no%20people&width=800&height=500&seq=card-05-influencer-life&orientation=landscape',
    tag: '深度',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            深扒图文
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            深度原创内容，从图文到分析，给你最详尽的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group block bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 hover:bg-background-100 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'h-52 md:h-64' : 'h-44 md:h-48'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span>{item.author}</span>
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.reads}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}